module.exports = __webpack_public_path__ + "img/top-1-5.07908847.jpg";